import styled from 'styled-components';
import { winnowHeading } from '../../../../../theme/typography';
import { themeColor } from '../../../../../theme/getters';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 32px;
  margin-top: 32px;

  border-top: 1px solid ${themeColor('border')};
`;

export const Label = styled.span`
  ${winnowHeading};
`;

export const Price = styled.span`
  ${winnowHeading};
  text-align: right;
`;
